import { trackClick } from 'lib/api/track-click';
import { getLocale } from 'lib/localization';
import { getCategoryPageServerSideProps, GetServerSidePropsType } from 'pages/[lang]/[...slug]';
export { default } from 'pages/[lang]/[...slug]';

const query = {
    slug: 'how-to',
};

export const getServerSideProps = async function ({
    locale,
    res,
    req,
    resolvedUrl,
}: GetServerSidePropsType) {
    const innerCall = await getCategoryPageServerSideProps(query);

    trackClick({
        req,
        lang: getLocale(req),
    });

    const serverSideProps = await innerCall({
        query,
        locale,
        res,
        req,
        resolvedUrl,
    });
    return serverSideProps;
};
